import { hasAccessTo } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/helper/has-access-to';
import classNames from 'classnames';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

import { RoutingConfiguration } from '@app/config/routing.config';
import { permissions } from '@app/core/authentication/authentication.slice';
import { useAppSelector } from '@app/core/hooks';
import { GroupEnum } from '@model/routing-configuration.model';

import * as css from './base-layout.module.scss';
import { Header } from './components/header/header';
import { GroupedMenuItem, Menu, MenuItem } from './components/menu/menu';

export const BaseLayout = (): React.JSX.Element => {
  const { t } = useTranslation();
  const perms = useAppSelector(permissions);

  const [isSmall, setIsSmall] = useState<boolean>(false);

  const groupedMenuItems: GroupedMenuItem[] = useMemo(() => {
    const groups = new Map<GroupEnum, MenuItem[]>();

    RoutingConfiguration.forEach((item) => {
      if (
        item.showInMenu &&
        perms &&
        (!item.permission || hasAccessTo(perms, item.permission)) &&
        item.group
      ) {
        const { group } = item;
        if (!groups.has(group)) {
          groups.set(group, []);
        }
        groups.get(group)!.push({
          label: t(item.labelKey),
          icon: item.icon,
          to: item.route,
        });
      }
    });

    return Array.from(groups.entries()).map(([group, items]) => ({
      group,
      items,
    }));
  }, [perms, t]);

  return (
    <div
      className={classNames(
        css.layout,
        isSmall ? css.smallLayout : css.normalLayout,
      )}>
      <Header />
      <Menu
        groupedMenuItems={groupedMenuItems}
        isSmall={isSmall}
        setIsSmall={setIsSmall}
      />
      <main>
        <Outlet />
      </main>
    </div>
  );
};
